<template>
  <Suspense>
    <HeaderFederatedWrapper :key="countryLocale"> </HeaderFederatedWrapper>
  </Suspense>
</template>

<script setup lang="ts">
// import FederatedLayout from './layouts/federatedLayout.vue'
import '../design-system/assets/css/tailwind.scss'
const { countryLocale } = useCountryLocale()
</script>
